import React from "react";

export const ServiceRequestsSvg = ({ pathNames }) => {
  const active = pathNames?.includes("/home/servicerequests");
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke={active ? "#ffffff" : "#667085"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-6l-2 3h-4l-2-3H2" />
          <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
        </g>
      </svg>
    </div>
  );
};

export default ServiceRequestsSvg;
